import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { ScoreText } from "../components/ScoreText";
import { Grid, Paper } from "@mui/material";

interface ScorebugProps {
  title: string;
  homeScore: number;
  awayScore: number;
  homeName: string;
  awayName: string;
  scale: number;
}

const ScorebugSets: React.FC<ScorebugProps> = ({ title, homeScore, awayScore, homeName, awayName, scale }) => {
  const fullWidth = scale + "vw";
  const halfWidth = (scale / 2) + "vw";
  const titleHeight = (scale / 8) + "vh";
  const titleFontSize = ((scale / 8) * 1) + "vh";
  const subtitleFontSize = ((scale / 8) * .75) + "vh";
  const scoreHeight = (scale / 2.5) + "vh";
  const scoreFontSize = ((scale / 2.5)) + "vh";

  return (
    
      <Grid container spacing={0}>
        <Grid item xs={12} display="flex" justifyContent="center">

          <Box
            bottom={0}
            left={0}
            width={fullWidth}
            px={"1px"}
            py={"1px"}
            bgcolor="black"
          >
            <Grid container spacing={0}>
              {/* Top row - smaller boxes */}
              <Grid item xs={12} display="flex" justifyContent="center">
                <Box
                  sx={{
                    height: titleHeight,
                    width: fullWidth,
                    marginBottom: "1px",
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    fontWeight: 600,
                    color: 'white',
                    bgcolor: "#f7941e"
                  }}
                >
                  <ScoreText size={titleFontSize} value={title} weight={500} spacing={"3px"} />
                </Box>
              </Grid>
              <Grid item xs={6} display="flex" justifyContent="flex-end">
                <Box
                  sx={{
                    height: titleHeight,
                    width: halfWidth,
                    borderTop: '6px solid #515151', // thick blue border
                    borderRight: '1px solid black', // thick blue border
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    fontWeight: 600,
                    color: 'white',
                    bgcolor: "#f7941e"
                  }}
                >
                  <ScoreText size={subtitleFontSize} value={awayName.toUpperCase()} weight={500} spacing={"3px"} />
                </Box>
              </Grid>
              <Grid item xs={6} display="flex" justifyContent="flex-start">
                <Box
                  sx={{
                    height: titleHeight,
                    width: halfWidth,
                    borderTop: '6px solid #515151', // thick blue border
                    borderLeft: '1px solid black', // thick blue border
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    fontWeight: 600,
                    color: 'white',
                    bgcolor: "#f7941e"
                  }}
                >
                  <ScoreText size={subtitleFontSize} value={homeName.toUpperCase()} weight={500} spacing={"3px"} />
                </Box>
              </Grid>
              <Grid item xs={6} display="flex" justifyContent="flex-end">
                <Box
                  sx={{
                    height: scoreHeight,
                    width: halfWidth,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    fontWeight: 800,
                    color: 'white',
                    bgcolor: "var(--bg-color)",
                    paddingRight: "1px",
                    marginLeft: "2px"
                  }}
                >
                  <Box
                    sx={{
                      height: scoreHeight,
                      width: halfWidth,
                      borderTop: '2px solid #f7941e', // thick blue border
                      borderBottom: '2px solid #f7941e', // thick blue border
                      borderLeft: '2px solid #f7941e', // thick blue border
                      borderRight: '2px solid #f7941e', // thick blue border
                      borderRadius: 0,
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      fontWeight: 800,
                      color: 'white',
                      bgcolor: "var(--bg-color)"
                    }}
                  >
                    <ScoreText size={scoreFontSize} value={awayScore} weight={900} />
                  </Box>
                </Box>
              </Grid>
              <Grid item xs={6} display="flex" justifyContent="flex-start">
                <Box
                  sx={{
                    height: scoreHeight,
                    width: halfWidth,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    fontWeight: 800,
                    color: 'white',
                    bgcolor: "var(--bg-color)",
                    paddingLeft: "1px",
                    marginRight: "2px"
                  }}
                >
                  <Box
                    sx={{
                      height: scoreHeight,
                      width: halfWidth,
                      borderTop: '2px solid #f7941e', // thick blue border
                      borderBottom: '2px solid #f7941e', // thick blue border
                      borderLeft: '2px solid #f7941e', // thick blue border
                      borderRight: '2px solid #f7941e', // thick blue border
                      borderRadius: 0,
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      fontWeight: 800,
                      color: 'white',
                      bgcolor: "var(--bg-color)"
                    }}
                  >
                    <ScoreText size={scoreFontSize} value={homeScore} weight={900} />
                  </Box>
                </Box>
              </Grid>
            </Grid>
          </Box>
        </Grid>
      </Grid>
  );
}
export default ScorebugSets;